import Command from '@/assets/js/command.js';
import { mapState } from 'vuex';
import { S3_REGION } from '@/assets/js/utils.js';
export default {
  props: {
    btnList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    userInfo: {
      type: Object,
      default: () => {
        return {};
      }
    },
    singChannel: {
      type: Object,
      default: () => {
        return {};
      }
    },
    nickName: String,
    organization: String,
    sourceLiveStatus: {
      default: ''
    },
    deviceType: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    activeBg: {
      type: String,
      default: 'green'
    },
    type: {
      type: String,
      default: 'operate'
    },
    currentRole: {
      type: String,
      default: ''
    },
    liveInfo: {
      type: Object,
      default: () => {}
    },
    slotIndex: {
      type: Number,
      default: 0
    },
    behaviorInfo: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  computed: {
    ...mapState({
      State: state => state
    }),
    activeRole() {
      let res = '';
      if (this.type == 'asRole' || JSON.stringify(this.btnList).indexOf('roleSetting') > -1) {
        if (this.State.crewInfo.rtilCode && this.State.crewInfo.rtilCode == this.singChannel.id) {
          res = 'setCrew'; // 当前是crew角色，并选择crew
        } else {
          res = 'cancelCrew';
        }
        if (this.currentRole) {
          res = this.currentRole;
        }
        this.selectItem = {
          ...this.btnText[res],
          type: res
        };
      }
      return res;
    },
    praivateBg() {
      // 私聊状态
      if (this.userInfo.channelMode == 0) {
        if (this.State.startPrivateInfo[this.userInfo.rtilCode] && this.State.startPrivateInfo[this.userInfo.rtilCode].includes(this.singChannel.id)) {
          return {
            cancelPrivateConversation: 'red'
          };
        } else {
          return {};
        }
      } else {
        if (this.State.privateInfo.rtilCode && this.State.privateInfo.rtilCode == this.singChannel.id) {
          return {
            cancelPrivateConversation: 'red'
          };
        } else {
          return {};
        }
      }
    },
    greenBg() {
      // 角色相关，统一角色，不同的操作对应统一的角色
      if (this.currentRole == 'setQuestionSpeaker') {
        return {
          hangUpInterview: 'green',
          setQuestionSpeaker: 'green'
        };
      } else {
        return {};
      }
    },
    iconColor() {
      let str = '';
      const {
        type
      } = this.selectItem;
      const array = ['setCrew', 'setSpeaker', 'interviewer', 'setQuestionSpeaker', 'setBroadcast', 'setPublicSpeaker'];
      if (array.includes(type)) {
        str = 'green';
      }
      return str;
    }
  },
  data() {
    return {
      isCancelTag: false,
      btnText: {
        // key值最好小写开头，避免与自定义的重复
        rename: {
          icon: 'el-icon-edit',
          text: 'Rename'
        },
        removeParticipant: {
          icon: 'el-icon-delete',
          text: 'Remove from program'
        },
        setCrew: {
          icon: 'iconfont icon-Crew',
          text: 'Production Crew'
        },
        cancelCrew: {
          icon: 'iconfont icon-universal_role',
          text: 'Participant'
        },
        startPrivateConversation: {
          icon: 'iconfont icon-keboda',
          text: 'Set private chat'
        },
        cancelPrivateConversation: {
          icon: 'iconfont icon-privatechat',
          text: 'Hang up private chat'
        },
        replace: {
          icon: 'iconfont icon-replace',
          text: 'Replace'
        },
        roleSetting: {
          icon: 'iconfont icon-universal_role',
          text: 'Role setting'
        },
        setSpeaker: {
          icon: 'iconfont icon-universal_speaker',
          text: 'Speaker'
        },
        cancelSpeaker: {
          icon: 'iconfont icon-universal_role',
          text: 'Participant'
        },
        cancelQuestionSpeaker: {
          icon: 'iconfont icon-universal_role',
          text: 'Participant'
        },
        hangUpInterview: {
          icon: 'iconfont icon-universal_role',
          text: 'Hang up interview'
        },
        setQuestionSpeaker: {
          icon: 'iconfont icon-universal_interviewer',
          text: 'Interviewer'
        },
        interviewer: {
          icon: 'iconfont icon-universal_interviewer',
          text: 'Interviewer'
        },
        setPublicTalk: {
          icon: 'iconfont icon-universal_interviewer',
          text: 'Set public talk'
        },
        cancelQuestioner: {
          icon: 'iconfont icon-universal_role',
          text: 'Participant'
        },
        cancelQuestionerRemove: {
          icon: 'iconfont icon-universal_role',
          text: 'Remove from Question queue'
        },
        setQuestioner: {
          icon: 'iconfont icon-universal_role',
          text: 'Participant'
        },
        addQuestioner: {
          icon: 'iconfont icon-questionerqueue',
          text: 'Add to Interviewer Queue'
        },
        audience: {
          icon: 'iconfont icon-universal_role',
          text: 'Audience'
        },
        toTop: {
          icon: 'iconfont icon-totop',
          text: 'To top'
        },
        participant: {
          icon: 'iconfont icon-universal_role',
          text: 'Participant'
        },
        denyRaiseHand: {
          icon: 'iconfont icon-universal_role',
          text: 'Remove from Raise hand queue'
        },
        setBroadcast: {
          icon: 'iconfont icon-universal_speaker',
          text: 'Broadcaster'
        },
        setPublicSpeaker: {
          icon: 'iconfont icon-universal_interviewer',
          text: 'Public speaker'
        },
        editTagName: {
          icon: 'iconfont icon-tagname',
          text: 'Edit tag name'
        },
        fullScreen: {
          icon: 'iconfont icon-quanping1',
          text: 'Full screen'
        },
        moveParty: {
          icon: 'iconfont icon-movepip',
          text: 'Move to'
        },
        SetTag: {
          icon: 'iconfont icon-default1',
          text: 'Tag as Main Window'
        },
        CancelTag: {
          icon: 'iconfont icon-default1',
          text: 'Cancel Tag'
        },
        anyWhereSetting: {
          icon: 'iconfont icon-shezhi3',
          text: 'Setting'
        },
        setting: {
          icon: 'iconfont icon-shezhi3',
          text: 'Setting'
        },
        mainwindow: {
          icon: 'iconfont icon-Vector3',
          text: 'mainwindow'
        },
        unMainwindow: {
          icon: 'iconfont icon-Vector3',
          text: 'unMainwindow'
        },
        uploadImage: {
          icon: 'el-icon-upload2',
          text: 'uploadImage'
        },
        fromComputer: {
          icon: '',
          text: 'fromComputer'
        },
        formImageGallery: {
          iconL: '',
          text: 'formImageGallery'
        }
      },
      setNameInfo: {
        show: false
      },
      showPopover: false,
      loading: {},
      dialogTableVisible: false,
      crewType: '',
      privateInfoTips: {
        show: false,
        title: 'partylineGuest.switchPrivateCon',
        content: '',
        save: 'partylineGuest.save'
      },
      removeInfoTips: {
        title: 'Remove the source',
        content: '<div class="end">Do you really want to remove the source? <p>After remove, live feeds will be terminated.</p></div>',
        cancel: 'Cancel',
        save: 'Delete',
        show: false
      },
      selectItem: {},
      activeIndex: '',
      uploadFileInfo: null,
      uploadParams: {},
      getUploadParams: {
        pageIndex: 1,
        pageSize: 20,
        nameLike: '',
        isDirectory: false,
        region: S3_REGION,
        service: 'pp',
        type: 1,
        directoryName: '/Partyline/gallery/image'
      },
      uploadObj: {}
    };
  },
  methods: {
    changeItmeVal(val) {
      this.selectItem = {
        ...this.btnText[val],
        type: val
      };
    },
    handleSelect(val) {
      // debugger
      if ((val === 'startPrivateConversation' || val === 'cancelPrivateConversation') && this.State.audioMatrixEnable) {
        this.$message.warning(this.$t('operationBtn.notAllowed'));
        return;
      }
      this.showPopover = false;
      if (val != 'setCrew' && val != 'cancelCrew') {
        // setCrew设置成功后在标记高亮
        this.selectItem = {
          ...this.btnText[val],
          type: val
        };
      }
      if (val == 'SetTag') {
        const params = {
          partyCode: this.State.partyCode,
          rtilCode: this.singChannel.id,
          tag: true
        };
        // this.State.rtilTagCode = this.singChannel.id
        this.axios.post('/partyline-backend/kiosk/tag', params).then(res => {
          if (res.data.errorCode != '0x0') {
            this.$message({
              type: 'error',
              message: res.data.result.errorIfno
            });
          } else {
            // this.$emit('setTag', 'isSetTag')
            // this.isCancelTag = true
            this.State.partyTag = this.singChannel.id;
          }
        });
      }
      if (val == 'CancelTag') {
        const params = {
          partyCode: this.State.partyCode,
          rtilCode: this.singChannel.id,
          tag: false
        };
        this.axios.post('/partyline-backend/kiosk/tag', params).then(res => {
          if (res.data.errorCode != '0x0') {
            this.$message({
              type: 'error',
              message: res.data.result.errorIfno
            });
          } else {
            // this.$emit('setTag')
            // this.isCancelTag = false
            this.State.partyTag = '';
          }
        });
      }
      if (val == 'rename') {
        this.setNameInfo.show = true;
        this.setNameInfo.hideBtn = true;
        this.setNameInfo.userInfo = {
          nickName: this.nickName,
          organization: this.organization,
          partyCode: this.State.partyCode,
          rtilCode: this.singChannel.id,
          userRtilCode: this.userInfo.rtilCode
        };
      } else {
        switch (val) {
          case 'removeParticipant':
            this.removeFn(val);
            break;
          case 'startPrivateConversation':
          case 'cancelPrivateConversation':
            this.privateConversationFn(val);
            break;
          case 'replace':
          case 'setSpeaker':
          case 'cancelSpeaker':
          case 'cancelQuestionSpeaker':
          case 'toTop':
          case 'setPublicTalk':
          case 'cancelQuestionerRemove':
          case 'setQuestionSpeaker':
          case 'addQuestioner':
          case 'denyRaiseHand':
          case 'hangUpInterview':
          case 'setBroadcast':
          case 'setPublicSpeaker':
          case 'participant':
          case 'editTagName':
          case 'moveParty':
          case 'fullScreen':
          case 'anyWhereSetting':
          case 'setting':
          case 'mainwindow':
          case 'unMainwindow':
          case 'fromComputer':
          case 'formImageGallery':
            this.sendEmitFn(val);
            break;
        }
      }
    },
    sendEmitFn(val) {
      // 组件内单独处理
      this.$emit('callback', {
        ...this.singChannel,
        type: val,
        nickName: this.nickName,
        rtilCode: this.singChannel.id,
        organization: this.organization,
        partyCode: this.singChannel.channel
      });
    },
    // rename
    setNickName(obj) {},
    returnImageName() {
      if (!this.behaviorInfo[this.slotIndex]) return;
      const dotIndex = this.behaviorInfo[this.slotIndex].lastIndexOf('.');
      return dotIndex !== -1 ? this.behaviorInfo[this.slotIndex].substring(0, dotIndex) : this.behaviorInfo[this.slotIndex];
    },
    // 私聊
    async privateConversationFn(val, str, privateRtilCode) {
      const params = {
        partyCode: this.State.partyCode,
        module: val,
        msg: {
          rtilCode: privateRtilCode || this.singChannel.id,
          crewRtilCode: this.State.crewInfo.rtilCode,
          realPartyCode: this.singChannel.channel
        }
      };
      if (val == 'startPrivateConversation') {
        if (this.State.privateInfo.rtilCode) {
          // 已经存在私聊
          this.privateInfoTips.show = true;
          this.privateInfoTips.cancel = this.$t('partylineGuest.cancel');
          this.privateInfoTips.content = this.$t('partylineGuest.hungContent');
        } else {
          Command.fn(params).then(data => {
            if (data.errorCode === '0x0') {}
          });
        }
        if (str == 'command') {
          if (this.State.privateInfo.rtilCode) {
            await Command.fn({
              partyCode: this.State.partyCode,
              module: 'cancelPrivateConversation',
              msg: {
                rtilCode: this.State.privateInfo.rtilCode,
                crewRtilCode: this.State.crewInfo.rtilCode,
                realPartyCode: this.singChannel.channel
              }
            }).then(data => {
              if (data.errorCode === '0x0') {
                this.State.privateInfo = {};
              }
            });
          }
          Command.fn(params).then(data => {
            if (data.errorCode === '0x0') {
              this.State.privateInfo = {
                crewRtilCode: this.State.crewInfo.rtilCode,
                rtilCode: this.singChannel.id
              };
            }
          });
        }
      }
      if (val == 'cancelPrivateConversation') {
        Command.fn(params).then(data => {
          if (data.errorCode === '0x0') {
            this.State.privateInfo = {};
          }
        });
      }
    },
    removeUploadImage() {
      var _this$userInfo$realPa;
      const params = {
        joinCode: this.userInfo.joinCode,
        realPartyCode: (_this$userInfo$realPa = this.userInfo.realPartyList) === null || _this$userInfo$realPa === void 0 ? void 0 : _this$userInfo$realPa[0].realPartyCode,
        slotNumber: this.slotIndex
      };
      this.axios.post('/partyline-backend/group/noLogin/delSlotImage', params).then(res => {
        if (res.data.errorCode === '0x0') {
          var _this$userInfo$realPa2;
          this.$message.success(this.$t('commonFunction.operateSuccessful'));
          this.$emit('callback', {
            type: 'getUploadImageList',
            partyCode: (_this$userInfo$realPa2 = this.userInfo.realPartyList) === null || _this$userInfo$realPa2 === void 0 ? void 0 : _this$userInfo$realPa2[0].realPartyCode
          });
        }
      });
    },
    removeFn(type, str) {
      var _this$State$imagePosi;
      if ((_this$State$imagePosi = this.State.imagePositionInfo) !== null && _this$State$imagePosi !== void 0 && _this$State$imagePosi[this.slotIndex]) {
        this.removeUploadImage();
        return;
      }
      // 先判断当前的source是否在live
      if (this.sourceLiveStatus && str != 'command' && this.deviceType != 'T' && this.deviceType != 'Anywhere') {
        this.removeInfoTips.show = true;
        return;
      }
      if ((this.deviceType == 'T' || this.deviceType == 'Anywhere') && this.liveInfo.livePeerId) {
        this.$message.warning(this.$t('operationBtn.notStopLive'));
      }
      if (this.loading[type] || !this.singChannel.channel || !this.State.partyCode) return;
      this.loading[type] = true;
      const params = {
        partyCode: this.singChannel.channel,
        groupId: this.userInfo.joinCode,
        rtilCode: this.singChannel.id
      };
      this.axios.post(`/partyline-backend/partyAction/removeParticipant?partyCode=${this.State.partyCode}`, params).then(res => {
        this.loading[type] = false;
        if (res.data.errorCode === '0x0') {
          // 在gallery view模式下需要 注意添加
          this.$emit('callback', {
            type: 'removePepole',
            rtilCode: this.singChannel.id,
            partyCode: this.singChannel.channel
          });
        }
      }).catch(() => {
        this.loading[type] = false;
      });
    },
    removeJoinkByVoIP(item) {
      const params = {
        partyCode: this.userInfo.joinCode,
        peerId: item.devicePeerId
      };
      this.axios.delete('/partyline-backend/commonParty/deviceRtilVoIP', {
        data: params
      }).then(res => {
        if (res.data.errorCode == '0x0') {
          this.$message({
            type: 'success',
            message: this.$t('setting.audioBackOperateSuccess')
          });
        }
      }).catch(e => {
        console.log(e);
      });
    },
    handleChange(file) {
      this.uploadFile = file;
    },
    judgeAllowUpload(file) {
      const isAllowUpload = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isAllowUpload) {
        this.$message.warning('Operation failed, the current picture is not jpeg or png.');
      } else {
        this.uploadFileInfo = file;
      }
      return isAllowUpload;
    },
    async uploadFileBySDK() {
      this.$set(this.State.uploadingImageInfo, this.slotIndex, true);
      const params = {
        region: S3_REGION,
        service: 'pp',
        directoryName: '/Partyline/gallery/image',
        fileName: this.uploadFile.name
      };
      this.axios.post('/file/request-upload-for-sdk', params, {
        requestBase: 'GATEWAY'
      }).then(res => {
        if (res.data.errorCode === '0x0') {
          const result = res.data.result;
          this.uploadParams = result;
          AWS.config.region = result.identityPoolRegion;
          AWS.config.credentials = new AWS.CognitoIdentityCredentials({
            IdentityPoolId: result.identityPoolId
          });
          this.getImageWidthHeight();
        }
      });
    },
    getImageWidthHeight() {
      const url = window.URL || window.webkitURL;
      const image = new Image();
      this.$emit('callback', {
        type: 'getUploadImageList',
        partyCode: this.userInfo.realPartyList[0].realPartyCode
      });
      image.onload = () => {
        this.doUploadFile(this.uploadParams, this.uploadFile, {
          width: image.width,
          height: image.height
        });
      };
      image.src = url.createObjectURL(this.uploadFileInfo);
    },
    doUploadFile(uploadParams, file, imageInfo) {
      const uploadObj = new AWS.S3.ManagedUpload({
        params: {
          Bucket: uploadParams.bucket,
          Key: uploadParams.objectKey,
          Body: file.raw,
          ACL: 'public-read'
        },
        service: new AWS.S3({
          region: uploadParams.region
        })
      });
      uploadObj.on('httpUploadProgress', progress => {
        const percent = Math.round(progress.loaded / progress.total * 100);
        this.$set(this.State.uploadImagePercent, this.slotIndex, percent);
      });
      uploadObj.promise().then(() => {
        this.addFile(uploadParams, imageInfo);
      });
    },
    addFile(uploadParams, imageInfo) {
      const params = {
        bucketId: uploadParams.bucketId,
        directoryId: uploadParams.directoryId,
        objectKey: uploadParams.objectKey
      };
      this.axios.post('/file/add-file', params, {
        requestBase: 'GATEWAY'
      }).then(res => {
        if (res.data.errorCode === '0x0') {
          this.getUploadImage(res.data.result, imageInfo);
        }
      });
    },
    getUploadImage(imageId, imageInfo) {
      this.getUploadParams.directoryName = '/Partyline/gallery/image';
      this.axios.post('/file/query-user-files', this.getUploadParams, {
        requestBase: 'GATEWAY'
      }).then(res => {
        if (res.data.errorCode === '0x0') {
          const list = res.data.result.records;
          list.forEach(item => {
            if (item.id == imageId) {
              // 把从电脑上设置的图片设为与会者
              this.setImgAsParticipant(item.id, item.url, imageInfo);
            }
          });
        }
      });
    },
    setImgAsParticipant(id, url, imageInfo) {
      var _this$userInfo$realPa3;
      const {
        width,
        height
      } = imageInfo;
      const params = {
        joinCode: this.userInfo.joinCode,
        realPartyCode: (_this$userInfo$realPa3 = this.userInfo.realPartyList) === null || _this$userInfo$realPa3 === void 0 ? void 0 : _this$userInfo$realPa3[0].realPartyCode,
        slotNumber: this.slotIndex,
        imageUrl: url,
        imageId: id,
        imageName: this.uploadParams.fileName,
        imageWidth: width,
        imageHeight: height
      };
      this.axios.post('/partyline-backend/group/noLogin/updateSlotImage', params).then(res => {
        if (res.data.errorCode === '0x0') {
          var _this$userInfo$realPa4;
          this.$message.success(this.$t('commonFunction.operateSuccessful'));
          this.getUploadImageInfo((_this$userInfo$realPa4 = this.userInfo.realPartyList) === null || _this$userInfo$realPa4 === void 0 ? void 0 : _this$userInfo$realPa4[0].realPartyCode);
          this.$delete(this.State.uploadImagePercent, this.slotIndex);
          this.$set(this.State.uploadingImageInfo, this.slotIndex, false);
        }
      });
    },
    getUploadImageInfo(partyCode) {
      this.axios.get('/partyline-backend/dictionary', {
        params: {
          partyCode,
          key: 'galleryImageSlotIndex'
        }
      }).then(res => {
        if (res.data.errorCode === '0x0') {
          this.State.imagePositionInfo = res.data.result ? JSON.parse(res.data.result) : {};
        }
      });
    }
  }
};